import { keyframes } from "@mui/material/styles";
import { SvgIconProps } from "@mui/material/SvgIcon";

import ScoutIcon from "./ScoutIcon";

const scoutSpin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

/** Holds still for people who ask for reduced motion. */
export function ScoutSpinningIcon({ sx, ...props }: SvgIconProps) {
  return (
    <ScoutIcon
      aria-hidden
      {...props}
      sx={[
        {
          animation: `${scoutSpin} 1.1s linear infinite`,
          "@media (prefers-reduced-motion: reduce)": { animation: "none" },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
}
